<div class="modal-body p-3 p-md-4">

  <div class="d-flex align-items-start justify-content-between mb-3">
    <div>
      <p class="fs-normal fw-800 color-gray-950 mb-0">{{'planner.delete_plan'|translate}}</p>
      <p class="fs-small fw-400 color-gray-400 mb-0">{{'planner.delete_plan_desc'|translate}}</p>
    </div>

    <a class="clickable color-gray-400 ms-2" (click)="modal.dismiss()" [ngbTooltip]="'buttons.close'|translate" container="body"><i class="bi bi-x-lg"></i></a>
  </div>

  <ngx-skeleton-loader
    *ngIf="isLoading" count="3" appearance="line"
    [theme]="{height: '52px', 'border-radius': '12px', margin: '0 0 8px 0'}"/>

  <ng-container *ngIf="!isLoading">
    <div class="applied-plan d-flex align-items-center justify-content-between p-3 mb-2"
         *ngFor="let plan of plans">
      <p class="fs-small fw-800 color-gray-950 mb-0">{{plan.title}}</p>

      <a class="text-danger clickable d-inline-flex align-items-center"
         [class.disabled]="removingPlanId === plan.id"
         (confirm)="remove(plan)" [swal]="{
           text: ('planner.delete_plan_confirm'|translate),
           showDenyButton: false,
           showCancelButton: true,
           cancelButtonText: 'buttons.cancel_l'|translate,
           confirmButtonText: 'buttons.yes'|translate,
           heightAuto: false
         }">
        <i class="bi bi-trash me-1"></i>{{'buttons.remove'|translate}}
      </a>
    </div>

    <p class="fs-small fw-400 color-gray-400 mb-0" *ngIf="!plans.length">
      {{'planner.no_applied_plan'|translate}}
    </p>
  </ng-container>

</div>
